"use client"
import {
    Box, Button,
    Container, Modal, Stack,
    Typography, useMediaQuery
} from "@mui/material";
import Grid from '@mui/material/Grid2';
import '../../assets/styles/scss/_userDeal.scss'
import DealCard from "./DealCard"
import DynoLoader from "../DynoLoader";
import RegisterationForm from "./RegisterationForm";
import { useEffect, useState } from "react";
import img1 from "../../assets/img/how_to_get_deal/s1.jpg";
import img2 from "../../assets/img/how_to_get_deal/s2.jpg";
import img3 from "../../assets/img/how_to_get_deal/s3.jpg";
import DealsHeader from './DealsHeader';
import dotLoader from "../../assets/loading/dotsLoader";
import { isPostHogActive } from "utils";
import { usePostHog } from "posthog-js/react";
import { useDeals } from "app/providers/deals-provider";
import { useFeatureFlagEnabled } from "posthog-js/react";

export default function DealsView(
    {
        selectedDeals,
        onDealSelect,
        showCheckBox,
        showSidebar = false,
        sidebarContent = null,
        propDeals = null,
    }) {

    const {
        deals: hookDeals,
        isDealLoading,
        userType,
        handleViewMore,
        hasMoreDeals
    } = useDeals();
    
    // Use prop deals if provided, otherwise use hook deals
    const deals = propDeals || hookDeals;
    
    const [openModal, setOpenModal] = useState(false);
    const [currentStep, setCurrentStep] = useState(1);
    const [selectedDeal, setSelectedDeal] = useState(null);
    const [dontShowAgain, setDontShowAgain] = useState(false);
    const isMobile = useMediaQuery('(max-width:1023px)');
    const posthog = usePostHog();
    const isShowEmailPopupEnabled = useFeatureFlagEnabled('show_deal_email_popup');

    useEffect(() => {
        // Check the preference to not show modal
        const modalPreference = localStorage.getItem('dealModalPreference');
        setDontShowAgain(modalPreference === 'true');
    }, []);

    const isDealSelected = (dealId) => {
        return !!selectedDeals?.find(deal => deal.productId === dealId);
    };

    const steps = [
        {
            type: 'form'
        },
        {
            image: img1,
            description: "Step 1: Welcome to our exclusive deal! Click next to learn more.",
            type: 'image'
        },
        {
            image: img2,
            description: "Step 2: This amazing offer is only available for a limited time!",
            type: 'image'
        },
        {
            image: img3,
            description: "Step 3: Ready to get your deal? Click next to proceed!",
            type: 'image'
        }
    ];

    const handleNext = () => {
        if (currentStep < steps.length) {
            setCurrentStep(currentStep + 1);
        } else {
            resetModal()
            if (dontShowAgain) {
                localStorage.setItem('dealModalPreference', 'true');
            }

            window.open(selectedDeal?.url, '_blank', 'noopener,noreferrer');
            if (isPostHogActive()) {
                posthog.capture("redirected_to_amazon", {
                    dealId: selectedDeal.productId,
                    category: selectedDeal.category
                });
            }
        }
    };

    function resetModal() {
        setCurrentStep(1)
        setOpenModal(false)
    }

    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: isMobile ? 360 : 550,
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: isMobile ? 1 : 2,
        borderRadius: 2,
    };

    return (
        <Container sx={{ width: "100%", maxWidth: "100%!important" }}>
            <DealsHeader />

            {!isDealLoading && deals && !deals.length && (
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        textAlign: "center",
                        mt: 15,
                    }}
                >
                    <Typography variant="h3" color="textSecondary">
                        Deals not found
                    </Typography>
                </Box>
            )}

            <Box id="deal-select-tour" sx={{
                display: 'flex',
                gap: 2,
                width: '100%',
                flexDirection: isMobile ? 'column' : 'row'
            }}>
                {/* Main Deals Grid */}
                <Box id="deals-cards-container-tour" sx={{
                    flex: showSidebar ? '0 0 80%' : '1',
                    width: showSidebar ? '80%' : '100%',
                    maxWidth: showSidebar ? '80%' : '100%'
                }}>
                    <Grid container>
                        {deals && deals.map((deal, index) => (
                            <DealCard
                                key={index}
                                deal={deal}
                                setOpenModal={setOpenModal}
                                setSelectedDeal={setSelectedDeal}
                                isDealSelected={isDealSelected}
                                onSelect={onDealSelect}
                                showCheckBox={showCheckBox}
                                showVariant={true}
                                isShowEmailPopupEnabled={isShowEmailPopupEnabled}
                            />
                        ))}
                    </Grid>
                </Box>

                {/* Sidebar */}
                {showSidebar && sidebarContent && (
                    <Box id="deal-selected-tour" sx={{
                        flex: '0 0 20%',
                        width: '20%',
                        maxWidth: '20%'
                    }}>
                        {sidebarContent}
                    </Box>
                )}
            </Box>

            {isDealLoading ? (
                <DynoLoader
                    height="300px"
                    width="100%"
                    justifyContent="center"
                    alignItems="center"
                    customLoader={dotLoader}
                    customLoaderWidth={"150px"}
                    customLoaderHeight={"150px"}
                />
            ) : (
                !!hasMoreDeals ? (
                    <div className="view-more-container">
                        <button
                            onClick={handleViewMore}
                            disabled={isDealLoading}
                            className="btn btn-primary view-more-button"
                        >
                            {isDealLoading ? "Loading..." : "View More Deals"}
                        </button>
                    </div>
                ) : (userType !== 'creator' && <RegisterationForm
                    hasDeals={deals && !!deals.length}
                />)
            )}

            <Modal
                open={openModal}
                onClose={() => resetModal()}
                aria-labelledby="deal-guide-modal"
            >
                <Box sx={modalStyle}>
                    <Stack spacing={1} alignItems="center">
                        {
                            steps[currentStep - 1].type === 'form' ?
                                (
                                    <RegisterationForm
                                        hasDeals={deals && !!deals.length}
                                        buttonColor="#5E60CE"
                                        setCurrentStep={setCurrentStep}
                                        currentStep={currentStep}
                                    />
                                )
                                :
                                (
                                    <>
                                        <img
                                            src={steps[currentStep - 1].image.src}
                                            alt={`Step ${currentStep}`}
                                            style={{
                                                width: isMobile ? '350px' : '100%',
                                                height: isMobile ? '250px' : '350px',
                                                borderRadius: '8px'
                                            }}
                                        />
                                        <Typography variant="h6" textAlign="center" className="mb-1 mt-3">
                                            {steps[currentStep - 1].description}
                                        </Typography>
                                    </>
                                )}
                        <Box
                            style={{ marginBottom: '10px' }}
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                width: '100%',
                            }}
                        >
                            <input
                                type="checkbox"
                                id="dontShowAgain"
                                checked={dontShowAgain}
                                onChange={(e) => setDontShowAgain(e.target.checked)}
                                style={{ marginRight: '8px' }}
                            />
                            <label htmlFor="dontShowAgain" style={{ fontSize: '14px' }}>
                                Don't show this message again
                            </label>
                        </Box>
                        <Button
                            variant="contained"
                            onClick={handleNext}
                            sx={{
                                backgroundColor: "var(--theme-dark)",
                                "&:hover": {
                                    backgroundColor: "var(--second-color)"
                                }
                            }}
                        >
                            {currentStep === steps.length ? "Get Deal" : "Next"}
                        </Button>
                    </Stack>
                </Box>
            </Modal>
        </Container>
    );
}
